import { toast } from "react-toastify"
import axiosInstance from "../../../../services/axios-client"
import { useState } from "react"

const useListPhase = () => {
    const [payload, setPayload] = useState([])
    const getListPhase = async () => {
        try {
            let res = await axiosInstance.get('/auth/phases')
            setPayload(res.data.data)
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const deleteProjectPhase = async (id) => {
        try {
            let res = await axiosInstance.delete(`/auth/phases/${id}`)
            if (res.status === 204) {
                toast.success("Success Delete Project")
                // Refresh the list without full page reload
                await getListPhase()
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }
    return {
        payload,
        getListPhase,
        deleteProjectPhase
    }
}

export default useListPhase